<template>
  <ion-page>
    <master-layout pageTitle="حجم روغن سوخته">
      <ion-card>
        <ion-card-content>
          <h5>حجم روغن فعلی :
          {{totalOil}}
          </h5>
          <DataTable :headers="headers" :route="route"></DataTable>
          <div class="between">
            <div></div>
            <div>
              جمع کل :
              {{orderOil}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";

export default {
  data()
  {
    return {
      id: null,
      totalOil : 0,
      orderOil : 0,
      route:'OilOrder/ListAjax',
      headers: [
        'شماره فاکتور',
        'نام مشتری',
        'تیپ خودرو',
        'روغن سوخته'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  methods: {
    ...mapActions("order", {
      getOilAmount: 'getOilAmount',
    }),
  },
  async mounted()
  {
    const check = await this.getOilAmount();
    if (check && check.ok)
    {
      this.orderOil = check.order_oil;
      this.totalOil = check.oil;
    }
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  },
  watch: {
    $route()
    {
      if (this.$route.fullPath.indexOf('OilOrder/ListAjax') >= 0)
      {
        this.route = 'OilOrder/ListAjax?t='+(new Date().getTime())
      }
    }
  }
};
</script>

<style scoped>
.between
{
  display: flex;
  justify-content: space-between;
}
</style>